import { Component, OnInit, inject } from '@angular/core';
import Smartlook from 'smartlook-client';
import { environment } from '@assets/environment/environment';
import { initializeApp } from 'firebase/app';
import { initializeAnalytics } from 'firebase/analytics';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from './shared/loader/loader.component';
import { BranchService } from './services/branch.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, LoaderComponent],
})
export class AppComponent implements OnInit {
  private branchService: BranchService = inject(BranchService);

  ngOnInit() {
    const firebaseConfig = {
      apiKey: 'AIzaSyDGNlpVd6jg__DaHoKgBbEgN30F4lSEhLc',
      authDomain: 'heykiddo-talk.firebaseapp.com',
      projectId: 'heykiddo-talk',
      storageBucket: 'heykiddo-talk.firebasestorage.app',
      messagingSenderId: '186541483259',
      appId: '1:186541483259:web:a17c781696196e1c69fc5e',
      measurementId: 'G-VR1N1SKSVJ',
    };
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);

    // Initialize Analytics and get a reference to the service
    initializeAnalytics(app);

    // Initialize Smartlook for user session recording
    Smartlook.init(environment.smartlookKey, {
      cookies: false,
      region: 'us',
      advancedNetwork: false,
    });

    // Initialize Branch.io for deep linking and attribution
    this.branchService.initialize().catch((error) => {
      console.error('Failed to initialize Branch.io:', error);
    });
  }
}
